import { render } from "./CompanyCard.vue?vue&type=template&id=6cc9adf1&scoped=true"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"

import "./CompanyCard.vue?vue&type=style&index=0&id=6cc9adf1&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc9adf1"]])

export default __exports__